module.exports = __webpack_public_path__ + "img/fade-right.75dc5c17.svg";